import { render, staticRenderFns } from "./FormControlMRegistrantsRegistrantsCreditAmount.vue?vue&type=template&id=6f5c6336&scoped=true"
import script from "./FormControlMRegistrantsRegistrantsCreditAmount.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMRegistrantsRegistrantsCreditAmount.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlMRegistrantsRegistrantsCreditAmount.vue?vue&type=style&index=0&id=6f5c6336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c6336",
  null
  
)

export default component.exports